import React, { useState } from "react";
import fire from "../../config/Fire";
import API from "../../utils/API";
import Modal from "react-modal";
import cogoToast from "@successtar/cogo-toast";
import { FEATURES } from "../../config/features";

const customStylesModal = {
  content: {
    padding: "5px 5px",
    backgroundImage: "linear-gradient(to top, lightblue 0%, whitesmoke 100%)",
    border: "0px",
    height: "100%",
    textAlign: "center"
  }
};

function LoginCard({ switchToSignup }) {
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const checkCredentials = (uid) => {
    console.log(uid + " has logged in");

    console.log("Looking for Client Login first");
    API.findClientLogin(uid)
      .then((res) => {
        console.log("Found client login");
        console.log(res);
        if (res.data.length > 0) {
          console.log("This is a client login");
          document.location.href = "/client";
        } else {
          console.log("Did not find a client login");
          console.log("This is not a client login");
          console.log("Looking for an agent login");
          API.findAgentLogin(uid)
            .then((res) => {
              if (res.data.length > 0) {
                console.log("This is an agent login");
                document.location.href = "/agent";
              } else {
                console.log("This is not an agent login");
                API.findAdminLogin(uid)
                  .then((res) => {
                    console.log("Found an admin login");
                    console.log(res);
                    if (res.data.length > 0) {
                      console.log("This is an admin login");
                      setTimeout(() => {
                        document.location.href = "/admin";
                      }, 5000);
                    } else {
                      console.log("This is not an admin login");
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                    console.log("This is not a proper login");
                  });
              }
            })
            .catch((_err) => console.log("Type of user not found"));
        }
      })
      .catch((_err) => console.log("This is not a proper login"));
  };

  const login = (e) => {
    e.preventDefault();
    fire
      .auth()
      .signInWithEmailAndPassword(formData.email, formData.password)
      .then((res) => {
        console.log(res.user.uid);
        console.log(res);
        checkCredentials(res.user.uid);
        document.cookie = "fawnuid=" + res.user.uid;
      })
      .catch((error) => {
        cogoToast.error("Error: " + error.message);
        console.log(error);
      });
  };

  const forgotPassword = (e) => {
    e.preventDefault();
    console.log("Forgot Password...");
    console.log("no code here yet");
    setShowForgotPassword(true);
  };

  const closeForgotPassword = (event) => {
    event.preventDefault();
    setShowForgotPassword(false);
  };

  const sendResetPasswordEmail = (event, email) => {
    event.preventDefault();
    // Pre-launch email rule (Evan, 2026-07-11): no Firebase reset emails to
    // anyone but evan@fawncircle.com until FEATURES.emailsLive. This legacy
    // card still ships on the redesign branch (AgentPage's internal modal),
    // so it gets the same gate as the rebuilt /login. The deployed-prod
    // copy of this residual is handled separately by the Coordinator.
    if (!FEATURES.emailsLive && (email || "").trim().toLowerCase() !== "evan@fawncircle.com") {
      cogoToast.info(
        "Password resets are handled personally right now — contact Evan at evan@fawncircle.com."
      );
      return;
    }
    console.log("Sending Password Reset Email for Email: ");
    console.log(email);
    fire
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        cogoToast.success("Password reset email sent!");
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode, errorMessage);
      });
  };

  const exitModal = (e) => {
    e.preventDefault();
    setShowForgotPassword(false);
  };

  return (
    <div
      className="opacity-60"
      style={{
        backgroundColor: "rgba(0,0,0,0.75)",
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%",
        height: "400px",
        color: "black",
        borderRadius: "5px"
      }}
    >
      <Modal
        isOpen={showForgotPassword}
        onRequestClose={(e) => closeForgotPassword(e)}
        style={customStylesModal}
      >
        <div style={{ height: "500px", width: "100%", textAlign: "center" }}>
          <form style={{ marginTop: "200px" }}>
            <h3>Password Reset</h3>
            <label className="form-group" style={{ color: "black" }}>
              <strong>Email your email to reset your password</strong>
            </label>
            <br />
            <br />
            <input
              type="text"
              className="form-group"
              value={formData.email}
              name="email"
              onChange={handleInputChange}
            />
            <br />
            <br />
            <button
              style={{ textAlign: "center", margin: "10px", width: "150px" }}
              onClick={(e) => {
                sendResetPasswordEmail(e, formData.email);
              }}
              className="btn btn btn-info"
            >
              <strong>Reset Password</strong>
            </button>
            <br />
            <button
              style={{ textAlign: "center", margin: "10px", width: "150px" }}
              onClick={(e) => {
                exitModal(e);
              }}
              className="btn btn btn-warning"
            >
              <strong>Exit</strong>
            </button>
          </form>
        </div>
      </Modal>

      <div>
        <div>
          <div style={{ textAlign: "center" }}>
            <form style={{ padding: "5%" }}>
              <label className="form-group" style={{ color: "white" }}>
                <strong>Email</strong>
              </label>
              <br />
              <input
                type="text"
                className="form-group"
                value={formData.email}
                name="email"
                onChange={handleInputChange}
              />
              <br />
              <label style={{ color: "white" }}>
                <strong>Password</strong>
              </label>
              <br />
              <input
                type="password"
                value={formData.password}
                name="password"
                onChange={handleInputChange}
              />
            </form>
            <br />
            <button
              style={{ textAlign: "center", margin: "10px", width: "150px" }}
              onClick={login}
              className="btn btn-sm btn-light"
            >
              <strong>Login</strong>
            </button>
            <br />
            <button
              style={{ textAlign: "center", margin: "10px", width: "150px" }}
              onClick={forgotPassword}
              className="btn btn-sm btn-light"
            >
              <strong>Forgot Password</strong>
            </button>
            <br />
            <button
              style={{ textAlign: "center", margin: "10px", width: "150px" }}
              onClick={() => switchToSignup()}
              className="btn btn-sm btn-light"
            >
              <strong>Create Account</strong>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginCard;
